import React from 'react';
import { observer } from 'mobx-react-lite';

import './style.sass';

import { useModel } from 'app/hooks/useViewModel';
import { Page } from 'app/components/common/PageLayout';
import { SignupPageViewModel } from 'app/viewModels/pages/SignupPageViewModel';
import { SignupForm } from 'app/components/SignupForm';


export const SignupPage = observer(() => {
    const {
        submitSignupForm,
        navigateToTheLogin,
        signUpWithApple,
        signUpWithGoogle,
        isLoading,
    } = useModel(SignupPageViewModel);

    return (
        <Page className="signup-page" isLoading={isLoading}>
            <div className="text-block">
                <h1 className="signup-page__title title-h1 dark-violet">Sign up on Explicit</h1>
                <p className="signup-page__desc p2-medium grey-1">Join an elite network leveraged by major record labels</p>
            </div>

            <SignupForm
                onSubmit={submitSignupForm}
                onClickLogin={navigateToTheLogin}
                onClickGoogleSignUp={signUpWithGoogle}
                onClickAppleSignUp={signUpWithApple}
            />
        </Page>
    );
});
